/**
 *
 * @author: Huning
 * @date: 2019-07-29
 *
 */
import React, { PureComponent, Fragment } from 'react'
import G2 from '@antv/g2'

class ChartLine extends PureComponent {
  static propTypes = {}

  static defaultProps = {}

  chart = null

  container = null

  componentDidMount() {
    const { data, scale } = this.props
    this.createChartInstance({ data, scale })
  }

  componentDidUpdate() {
    const { data, scale } = this.props
    this.repaintChartInstance({ data, scale })
  }

  componentWillUnmount() {
    if (this.chart) {
      this.chart.destroy()
      this.chart = null
    }
    this.container = null
  }

  createChartInstance = config => {
    const { data, scale, defs } = config
    const tooltip = { crosshairs: { type: 'line' } }
    this.chart = new G2.Chart({
      container: this.container,
      forceFit: true
    })
    this.chart.source(data, defs)
    this.chart.scale({ ...scale })
    this.chart.axis('y', {
      title: {
        offset: 70,
        position: 'middle',
        textStyle: {
          textAlign: 'middle',
          fill: '#aaaaaa'
        }
      },
      label: {
        textStyle: {
          fill: '#444444'
        },
        formatter: function formatter(text) {
          return text.replace(/(\d)(?=(?:\d{3})+$)/g, '$1,');
        }
      }
    })
    this.chart.tooltip({ ...tooltip })
    this.chart
      .line()
      .position('x*y')
      .color('name', ['rgb(79, 168, 249)', '#ff4d4f', 'rgb(110, 199, 30)', 'rgb(237, 176, 13)'])
      .size(3)
    this.chart.render()
  }

  repaintChartInstance = config => {
    if (this.chart) {
      this.chart.changeData(config.data, config.defs)
    } else {
      this.createChartInstance(config)
    }
  }

  portalRef = container => {
    if (!this.container) {
      this.container = container
    }
  }

  render() {
    const { props, state } = this
    return (
      <Fragment>
        <div ref={this.portalRef}>{this.props.children}</div>
      </Fragment>
    )
  }
}

export default ChartLine
